import { useState } from 'react';
import Button, { BUTTON_TYPE_CLASSES } from '../../../components/button/button.component';
import Image from '../../../components/image/image.component';
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import InputField from '../../Input-field/input-field.component';
import { user_forgetpass } from '../../../Services/prod/auth.service';
import Alert, { ALERT_TYPE } from '../../alert/alert.component';
import { CMlogo, CMLabel, CMContainer,CMButton } from './forgot-password-input-email.styles';
const ForgotPasswordInputEmail = ({ handleNext, formProps }) => {
    const { values, errors, touched } = formProps;
    const [status, setStatus] = useState('');
    const [isDisabled, setIsDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');

    const validationSchema = Yup.object({
        email: Yup.string().required('Email is required')
    });

    const handleKey = (e) => {
        setEmail(e.target.value);
        setIsDisabled(false);
    }

    const handleSubmit = async () => {
        setStatus('');
        setLoading(true);

        try {
            const data = await user_forgetpass(values.email);
            if (data && data.isSuccess === true) {
                console.log(data);
                handleNext();
            } else {
                setStatus(data.message);
            }
        } catch (error) {
            console.error('Error:', error);
            setStatus('An error occurred.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
        <CMlogo>
        <div className='title'>
                <Image src={'logo.png'} alt={'Music Bull'} width={150} />
                <h2>Forgot Password</h2>
        </div>
        </CMlogo>
          
            <Form>
            <CMContainer>

                <div className="container">

                {status &&
                    <Alert style={{ margin: "0px 0px 1rem" }} alertType={ALERT_TYPE.error}>{status}</Alert>
                }
                    <label htmlFor="totalUnit" className='labelTotalUnit'>Email</label>
                    <InputField
                        type="text"
                        id="email"
                        name="email"
                        value={values.email}
                        isInvalid={errors.email} error={errors.email}
                        onKeyUp={handleKey}
                    />
                </div>
                </CMContainer>
                <CMButton>
                <div className="button-container">
                    <Button type="button" disabled={isDisabled || errors.email || loading} buttonType={BUTTON_TYPE_CLASSES.BaseButton} onClick={handleSubmit} color="blue">
                        {loading ? 'Sending...' : 'Send'}
                    </Button>
                </div>
                </CMButton>
              
              

            </Form>
        </>
    )
}

export default ForgotPasswordInputEmail;
